<template>
  <el-form-item :label="i18nt('designer.setting.readMode')">
    <el-switch v-model="optionModel.readMode"></el-switch>
  </el-form-item>
</template>

<script>
  import i18n from "../../../../../utils/i18n"

  export default {
    name: "readMode-editor",
    mixins: [i18n],
    props: {
      designer: Object,
      selectedWidget: Object,
      optionModel: Object,
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// readMode-editor.vue?1113f568